/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductCategoryResponseDto
 */
export interface ProductCategoryResponseDto {
    /**
     * Category ID
     * @type {number}
     * @memberof ProductCategoryResponseDto
     */
    id: number;
    /**
     * Category name/code
     * @type {string}
     * @memberof ProductCategoryResponseDto
     */
    name: string;
    /**
     * Category image URL
     * @type {string}
     * @memberof ProductCategoryResponseDto
     */
    imageUrl: string | null;
}

/**
 * Check if a given object implements the ProductCategoryResponseDto interface.
 */
export function instanceOfProductCategoryResponseDto(value: object): value is ProductCategoryResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    return true;
}

export function ProductCategoryResponseDtoFromJSON(json: any): ProductCategoryResponseDto {
    return ProductCategoryResponseDtoFromJSONTyped(json, false);
}

export function ProductCategoryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategoryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'imageUrl': json['imageUrl'],
    };
}

export function ProductCategoryResponseDtoToJSON(value?: ProductCategoryResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'imageUrl': value['imageUrl'],
    };
}

